import { useMap } from 'react-use';

import { LabelFilters } from '@app/features/label/types';

function useLabelsFilter() {
  return useMap<LabelFilters>({
    sortBy: 'createdAt',
    bookmarkFirst: true,
    order: 'DESC',
  });
}

export default useLabelsFilter;
